import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function getAgreementById(leadId, callback) {
	var data;
	await firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId)
		.on('value', async (snapshot) => {
			data = snapshot.val();
			const individualObjs = data?.clientInfo?.individual;
			if (individualObjs) {
				const individualObjsKeys = Object.keys(individualObjs);
				let newDataReturn = {};

				individualObjsKeys.map((key) => {
					let copyObj = individualObjs?.[key];
					let newKey = individualObjs?.[key]?.id;
					newDataReturn[newKey] = copyObj;
					delete data.clientInfo.individual[key];
					data.clientInfo.individual[newKey] = copyObj;
				});
				data.clientInfo.individual = newDataReturn;
			}
			console.log('getAgreementById data', data);
			callback(data);
		});
}
